/**
 * "2 jam lalu" — MURNI, tanpa React.
 *
 * Pemberitahuan dibaca sambil lewat, dan yang ditanyakan pembacanya bukan "pukul berapa" melainkan
 * "baru atau lama". Jam dinding menuntut pengurangan di kepala; jarak waktu tidak.
 */

const MENIT = 60_000;
const JAM = 60 * MENIT;
const HARI = 24 * JAM;

export function waktuRelatif(iso: string, sekarang: Date): string {
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return '';

  const selisih = sekarang.getTime() - t;

  /*
   * Stempel waktu dari MASA DEPAN tidak pernah ditulis sebagai angka negatif.
   *
   * Jam ponsel yang meleset beberapa menit dari jam server adalah hal biasa di lapangan, dan
   * "-3 menit lalu" membuat pembacanya menyimpulkan aplikasinya rusak — padahal yang meleset
   * jamnya sendiri. Selisih ke depan diperlakukan sebagai baru saja, karena memang itu artinya.
   */
  if (selisih < MENIT) return 'baru saja';

  if (selisih < JAM) {
    return `${Math.floor(selisih / MENIT)} menit lalu`;
  }
  if (selisih < HARI) {
    return `${Math.floor(selisih / JAM)} jam lalu`;
  }
  if (selisih < 2 * HARI) return 'kemarin';
  if (selisih < 7 * HARI) {
    return `${Math.floor(selisih / HARI)} hari lalu`;
  }

  /*
   * Lewat sepekan, jarak berhenti bermakna: "23 hari lalu" menuntut pembacanya menghitung mundur
   * di kalender. Tanggalnya sendiri lebih pendek DAN lebih berguna.
   */
  return new Date(t).toLocaleDateString('id-ID', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}
